export default "__VITE_ASSET__nw3gcpZw__"